import { IFileInfo } from '../type';

//actionType
const FILE_LIST = 'fileList';
const IS_FROM_SERVE_RENDER = 'isFromServeRender';
const FILE_SUBMIT_STATUS = 'fileSubmitStatus';

// initialSate
const initialState = () => ({
  fileList: [],
  isFromServeRender: true,
  fileSubmitStatus: '选择文件上传',
});

//reducer
export default function fileReducer(state = initialState(), action = { type: '', data: '' }) {
  switch (action.type) {
    case FILE_LIST:
      return Object.assign({}, state, { fileList: action.data });
    case IS_FROM_SERVE_RENDER:
      return Object.assign({}, state, { isFromServeRender: action.data });
    case FILE_SUBMIT_STATUS:
      return Object.assign({}, state, { fileSubmitStatus: action.data });
    default:
      return state;
  }
}

//action
export const updateFileList = (data: IFileInfo[]) => ({
  type: FILE_LIST,
  data,
});

export const updateIsFromServeRender = (data: boolean) => ({
  type: IS_FROM_SERVE_RENDER,
  data,
});

export const updateFileSubmitStatus = (data: string) => ({
  type: FILE_SUBMIT_STATUS,
  data,
});
